import moment from 'moment';
import momentTz from 'moment-timezone';

export const toPickerDateByTimezone = (value, timeZone) => {
    if (!value) return null;

    const utcMoment = momentTz.utc(value);
    if (!utcMoment.isValid()) return null;

    const tzMoment = timeZone ? utcMoment.clone().tz(timeZone) : utcMoment;
    return moment({
        year: tzMoment.year(),
        month: tzMoment.month(),
        date: tzMoment.date(),
        hour: tzMoment.hour(),
        minute: tzMoment.minute(),
        second: tzMoment.second(),
        millisecond: tzMoment.millisecond()
    }).toDate();
};

export const fromPickerDateByTimezone = (value, timeZone) => {
    if (!value) return null;

    const pickerMoment = moment(value);
    if (!pickerMoment.isValid()) return null;

    if (!timeZone) {
        return pickerMoment.toISOString();
    }

    const zonedMoment = momentTz.tz({
        year: pickerMoment.year(),
        month: pickerMoment.month(),
        date: pickerMoment.date(),
        hour: pickerMoment.hour(),
        minute: pickerMoment.minute(),
        second: pickerMoment.second(),
        millisecond: pickerMoment.millisecond()
    }, timeZone);

    return zonedMoment.utc().toISOString();
};
